enum CookieKeys {
  AccessToken = 'joggo.session',
  Cart = 'joggo.anonymous_cart',
  Visited = 'joggo.simulator_visited'
}

export default CookieKeys
